import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import IndexPage from 'flarum/forum/components/IndexPage';
import ItemList from 'flarum/common/utils/ItemList';
import Button from 'flarum/common/components/Button';
import LogInModal from 'flarum/common/components/LogInModal';
import SignUpModal from 'flarum/common/components/SignUpModal';
import listItems from 'flarum/common/helpers/listItems';
import avatar from 'flarum/common/helpers/avatar';

export default class Sidebar extends Component {
  view() {
    const indexPage = new IndexPage();
    const navItems = indexPage.navItems();
    const newDiscussion = indexPage.sidebarItems().get('newDiscussion');

    return m('div', { className: 'MoeSidebar' }, [
      m('div', { className: 'MoeSidebar-brand' }, [
        m('span', { className: 'MoeSidebar-logo' }, app.forum.attribute('title')),
      ]),
      newDiscussion ? m('div', { className: 'MoeSidebar-new' }, newDiscussion) : null,
      m('nav', { className: 'MoeSidebar-nav' }, [
        m('ul', listItems(navItems.toArray())),
      ]),
      m('div', { className: 'MoeSidebar-session' }, this.sessionItems().toArray()),
    ]);
  }

  sessionItems() {
    const items = new ItemList();
    const user = app.session.user;

    if (user) {
      items.add(
        'user',
        m('div', { className: 'MoeSidebar-user' }, [avatar(user), m('span', { className: 'MoeSidebar-username' }, user.displayName())])
      );
      items.add(
        'logout',
        Button.component(
          { className: 'Button Button--link MoeSidebar-logout', icon: 'fas fa-sign-out-alt', onclick: () => app.session.logout() },
          app.translator.trans('core.forum.header.log_out_button')
        )
      );
    } else {
      items.add(
        'login',
        Button.component(
          { className: 'Button Button--primary Button--block', onclick: () => app.modal.show(LogInModal) },
          app.translator.trans('core.forum.header.log_in_link')
        )
      );
      if (app.forum.attribute('allowSignUp')) {
        items.add(
          'signup',
          Button.component(
            { className: 'Button Button--block', onclick: () => app.modal.show(SignUpModal) },
            app.translator.trans('core.forum.header.sign_up_link')
          )
        );
      }
    }

    return items;
  }
}
